var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationObserver", {
    ref: "reviewForm",
    staticClass: "product-overlay__review-form",
    attrs: { tag: "form", novalidate: "" },
    on: {
      submit: function($event) {
        $event.preventDefault()
        return _vm.onReviewSubmit.apply(null, arguments)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var invalid = ref.invalid
          var errors = ref.errors
          return [
            _vm.reviewResponse.message
              ? _c("GeneralMessage", {
                  attrs: {
                    message: _vm.reviewResponse.message,
                    type: _vm.reviewResponse.type
                  },
                  on: {
                    close: function($event) {
                      _vm.reviewResponse.message = ""
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isLoggedIn
              ? _c("ValidationProvider", {
                  attrs: {
                    name: "email",
                    rules: "required|email",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                      email: _vm.$t("forms.errors.emailInvalid")
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "email",
                                name: "email",
                                autocomplete: "email",
                                placeholder: _vm.$t("forms.labels.email"),
                                label: _vm.$t("forms.labels.email"),
                                error: errors.length > 0,
                                readonly: !!_vm.isLoggedIn,
                                disabled: _vm.loading,
                                required: ""
                              },
                              on: { input: _vm.onInput },
                              model: {
                                value: _vm.reviewForm.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.reviewForm, "email", $$v)
                                },
                                expression: "reviewForm.email"
                              }
                            }),
                            _vm._v(" "),
                            invalid && validated
                              ? _c("span", {
                                  staticClass: "input-error",
                                  domProps: { innerHTML: _vm._s(errors[0]) }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "additional-info",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "shoplist.product.details.ratings.emailHint"
                                  )
                                )
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _c("ValidationProvider", {
              attrs: {
                name: "firstname",
                rules: "required",
                tag: "div",
                customMessages: { required: _vm.$t("forms.errors.fieldEmpty") }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      var invalid = ref.invalid
                      var validated = ref.validated
                      return [
                        _c("FormInput", {
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t(
                              "shoplist.product.details.ratings.nameLabel"
                            ),
                            label: _vm.$t(
                              "shoplist.product.details.ratings.nameLabel"
                            ),
                            name: "name",
                            error: errors.length > 0,
                            disabled: _vm.loading,
                            required: ""
                          },
                          on: { input: _vm.onInput },
                          model: {
                            value: _vm.reviewForm.title,
                            callback: function($$v) {
                              _vm.$set(_vm.reviewForm, "title", $$v)
                            },
                            expression: "reviewForm.title"
                          }
                        }),
                        _vm._v(" "),
                        invalid && validated
                          ? _c("span", {
                              staticClass: "input-error",
                              domProps: { innerHTML: _vm._s(errors[0]) }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "additional-info",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "shoplist.product.details.ratings.nameHint"
                              )
                            )
                          }
                        })
                      ]
                    }
                  }
                ],
                null,
                true
              )
            }),
            _vm._v(" "),
            _c("ValidationProvider", {
              attrs: {
                name: "comment",
                rules: "required",
                tag: "div",
                customMessages: { required: _vm.$t("forms.errors.fieldEmpty") }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      var invalid = ref.invalid
                      var validated = ref.validated
                      return [
                        _c("FormInputTextarea", {
                          attrs: {
                            placeholder: _vm.$t(
                              "shoplist.product.details.ratings.commentLabel"
                            ),
                            label: _vm.$t(
                              "shoplist.product.details.ratings.commentLabel"
                            ),
                            name: "comment",
                            error: errors.length > 0,
                            disabled: _vm.loading,
                            required: ""
                          },
                          on: { input: _vm.onInput },
                          model: {
                            value: _vm.reviewForm.comment,
                            callback: function($$v) {
                              _vm.$set(_vm.reviewForm, "comment", $$v)
                            },
                            expression: "reviewForm.comment"
                          }
                        }),
                        _vm._v(" "),
                        invalid && validated
                          ? _c("span", {
                              staticClass: "input-error",
                              domProps: { innerHTML: _vm._s(errors[0]) }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                true
              )
            }),
            _vm._v(" "),
            _c("ValidationProvider", {
              attrs: {
                name: "rating",
                rules: "required",
                tag: "div",
                customMessages: {
                  required: _vm.$t(
                    "shoplist.product.details.ratings.errorRating"
                  )
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      var invalid = ref.invalid
                      var validated = ref.validated
                      return [
                        _c("FormInputRating", {
                          attrs: {
                            legend: _vm.$t(
                              "shoplist.product.details.ratings.ratingLabel"
                            ),
                            name: "rating",
                            error: errors.length > 0,
                            disabled: _vm.loading,
                            required: ""
                          },
                          on: { input: _vm.onInput },
                          model: {
                            value: _vm.reviewForm.rating,
                            callback: function($$v) {
                              _vm.$set(_vm.reviewForm, "rating", $$v)
                            },
                            expression: "reviewForm.rating"
                          }
                        }),
                        _vm._v(" "),
                        invalid && validated
                          ? _c("span", {
                              staticClass: "input-error",
                              domProps: { innerHTML: _vm._s(errors[0]) }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                true
              )
            }),
            _vm._v(" "),
            _c("Button", {
              staticClass: "form-button",
              attrs: {
                type: "submit",
                level: "primary",
                text: _vm.$t("shoplist.product.details.ratings.formButton"),
                disabled: _vm.loading
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "additional-info additional-info--align text--highlight",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("shoplist.product.details.ratings.formHint")
                )
              }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }